import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { getRadiusFromTheme } from '../../Common/helper/ThemeHelper';
import DataTestConst from '../../config/DataTestConst';

type PlusMinusQuantityButtonProps = {
    quantity: number,
    onAdd: () => void,
    onMinus: () => void,
    padding: number,
    isSRender?: boolean,
    smallButtons?: boolean,
    dataTestSuffix?: string,
    maximumValue?: number;
};

//This component take all available space it needs a container to the right size
const PlusMinusQuantityButton = (props: PlusMinusQuantityButtonProps) => {

    const {
        quantity,
        onAdd,
        onMinus,
        padding,
        isSRender,
        smallButtons,
        maximumValue
    } = props;

    const theme = useTheme();

    // The size of + and - buttons
    const squareSize: string = smallButtons ? "35px" : "58px";
    const digitSquareSize: string = smallButtons ? "12px" : "20px";

    const isMinusDisabled = quantity <= 0;
    const isAddDisabled = maximumValue !== undefined && quantity >= maximumValue;

    return (
        <Box
            display="flex"
            height="100%"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            marginTop={2}
            px={padding + "px"}
            borderRadius={getRadiusFromTheme(theme)}
            gap={smallButtons ? 2 : 4}
        >

            <IconButton
                data-test={props.dataTestSuffix ? `${DataTestConst.DECREASE_QUANTITY}_${props.dataTestSuffix}` : DataTestConst.DECREASE_QUANTITY}
                onClick={onMinus}
                disabled={isMinusDisabled}
                sx={{
                    height: squareSize,
                    width: squareSize,
                    borderRadius: getRadiusFromTheme(theme),
                    border: `1px solid ${isMinusDisabled ? theme.palette.secondary.light : theme.palette.secondary.main}`,
                    '&:hover': {
                        backgroundColor: !isMinusDisabled ? theme.palette.secondary.light + '20' : 'transparent',
                    },
                    '&.Mui-disabled': {
                        border: `1px solid ${theme.palette.secondary.light}`,
                    }
                }}
            >
                <RemoveIcon
                    color={isMinusDisabled ? 'disabled' : 'secondary'}
                    fontSize='small'
                />
            </IconButton>

            <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                height={digitSquareSize}
                width={digitSquareSize}
            >
                <Typography
                    variant={isSRender ? "h2" : "h5"}
                    color='secondary'
                >
                    {quantity}
                </Typography>
            </Box>

            <IconButton
                data-test={props.dataTestSuffix ? `${DataTestConst.INCREASE_QUANTITY}_${props.dataTestSuffix}` : DataTestConst.INCREASE_QUANTITY}
                onClick={onAdd}
                disabled={isAddDisabled}
                sx={{
                    height: squareSize,
                    width: squareSize,
                    borderRadius: getRadiusFromTheme(theme),
                    border: `1px solid ${isAddDisabled ? theme.palette.secondary.light : theme.palette.secondary.main}`,
                    '&:hover': {
                        backgroundColor: !isAddDisabled ? theme.palette.secondary.light + '20' : 'transparent',
                    },
                    '&.Mui-disabled': {
                        border: `1px solid ${theme.palette.secondary.light}`,
                    }
                }}
            >
                <AddIcon
                    color={isAddDisabled ? 'disabled' : 'secondary'}
                    fontSize='small'
                />
            </IconButton>

        </Box >
    );

}

PlusMinusQuantityButton.defaultProps = { padding: 10 }

export default PlusMinusQuantityButton